/* eslint-disable no-unused-vars */

/*this enum determines the list of ExecutionStrategyStatus, 
last reviewed 02/04/2026.

          -------------NOTE---------------
          that adding to this Enum, will automatically add 
          to the filtering list for the status column in the trade blotter
          FOR BOTH OP AND RP

*/
export enum ExecutionStrategyStatus {
  New = "New",
  Cancelled = "Cancelled",
  Sent = "Sent",
  Quoted = "Quoted",
  OffQuote = "Off-Quote",
  ReQuoteRequested = "Re-Quote Requested",
  QuoteExpired = "Quote Expired",
  Awarded = "Awarded",
  Executed = "Executed",
  Affirmed = "Affirmed",
  Recalled = "Recalled",
  Rejected = "Rejected",
  NotDealt = "Not Dealt",
  DealtAway = "Dealt Away",
  Acknowledged = "Acknowledged",
  ReSent = "Re-Sent",
  Received = "Received",
  Working = "Working",
  Filled = "Filled",
  ExecutedRPChangeRequested = "Executed - RP Change Requested", 
  ExecutedRPAgreeChange = "Executed - RP Agree Change", 
  ExecutedOPChangeRequested = "Executed - OP Change Requested",
  ReCreated = "Re-created",
  NoMoreFills = "No More Fills",
  ChangePending = "Change Pending",
  // TRADE expiry (expiryEnd) lapsed - NOT the same as QuoteExpired, which is an
  // RP's quote going stale. See docs/features/TRADE_EXPIRY.md (LQC-2173).
  Expired = "Expired",

  // InvalidQuote = "Invalid Quote", // I don't think we use this any more.
  // ExecutedPend = "Executed-Pend", // I don't think we use this any more.
  // AffirmedPend = "Affirmed-Pend", // I don't think we use this any more.
  // Archived = "Archived", // I don't think we use this any more.
  // OrderPulled = "Order Pulled", // I don't think we use this any more.
  // Pulled = "Pulled", // I don't think we use this any more.
  // LevelAccepted = "Level Accepted", // Deprecated -- Maybe this will come with the update to LEVELs.
  // LevelUpdated = "Level Updated", // Deprecated -- Maybe this will come with the update to LEVELs.
  // LevelUpdatedCP = "Level Updated - CP", // Deprecated -- Maybe this will come with the update to LEVELs.
  // FilledIncomplete = "Filled - Incomplete", // Deprecated
  // PartiallyFilled = "Partially Filled", // Deprecated
  // ExecutedPendRPChangeRequested = "Executed-Pend - RP Change Requested", // I don't think we use this any more
  // ExecutedPendRPAgreeChange = "Executed-Pend - RP Agree Change", // I don't think we use this any more
  // ExecutedPendOPChangeRequested = "Executed-Pend - OP Change Requested", // I don't think we use this any more
  // ReCouponRequest = "Recoupon Request", // I don't think we use this any more. ONLY for C1
  // ReCouponed = "Recouponed", // I don't think we use this any more. ONLY for C1
  // ReCouponChangeRequested = "Recoupon Change Requested", // I don't think we use this any more.
}
